import { useState, useEffect } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";

function BadShuttieSummary(props) {
  const [summary, setSummary] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let element = document.getElementById("chart");
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
    if (summary !== null) {
      try {
        window.Bokeh.embed.embed_item(summary, "chart");
      } catch (error) {
        console.log(error);
        setError(error);
      }
    }
  }, [summary]);
  useEffect(() => {
    setIsLoading(true);
    FleetWebApi.getBadShuttieReportSummary()
      .then((response) => {
        setSummary(response);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError(error.message);
        setIsLoading(false);
      });
  }, []);

  return (
    <Container>
      {isLoading && <CircularProgress color="secondary" />}
      {error && <p>Error Loading Data: {error}</p>}
      <div id="chart" className="bk-root"></div>
    </Container>
  );
}

export default BadShuttieSummary;
